import React from 'react'
import './../../assets/css/badge.css'

interface IComponentProps {
  title?: string;
  color?: string;
}

class Badge extends React.Component<IComponentProps> {
  render() {
    return (
      <div
        className="badge__container"
        style={{background: this.props.color?this.props.color:"#0008"}}
      >
        {this.props.title}
      </div>
    )
  }
}
export default Badge